var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col outer-box"},[_c('div',{staticClass:"innerBox",staticStyle:{"height":"100%"}},[_c('h2',{staticStyle:{"text-align":"center","font-weight":"700"}},[_vm._v("Top 10 Retail Sales By City")]),_c('div',{ref:"retailSalesByCity",staticStyle:{"height":"480px"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }